import React, { useMemo } from 'react';
import { Clickable } from '@moda/om';
import { VariantCellQuickAddFragment } from '../../../../../generated/types/VariantCellQuickAddFragment';
import { getActiveVariantBy } from '../../../../../lib/getActiveVariantBy';
import { useAddToBag } from '../../../../../hooks/useAddToBag';
import './VariantCellCallToAction.scss';

type Props = {
  variant: VariantCellQuickAddFragment;
  activeVariantId: string;
  href: string;
  onClickQuickView(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
};

export const VariantCellCallToAction: React.FC<Props> = ({
  variant,
  activeVariantId,
  href,
  onClickQuickView
}) => {
  const activeVariant = useMemo(() => getActiveVariantBy(variant, 'id', activeVariantId), [
    activeVariantId,
    variant
  ]);

  const { disabled, text, isOneSizedItem, handleAddToBag } = useAddToBag({
    activeVariantId: activeVariant.id,
    variant,
    position: 1,
    size: activeVariant.inventory[0],
    href,
    validatesSizePresenceOn: 'always'
  });

  if (!isOneSizedItem) {
    return (
      <Clickable className="VariantCellCallToAction" name="add" onClick={onClickQuickView}>
        Quick Add
      </Clickable>
    );
  }
  return (
    <Clickable className="VariantCellCallToAction" disabled={disabled} onClick={handleAddToBag}>
      {text}
    </Clickable>
  );
};
